
<p-table #dt [value]="lancamentosExibidos" dataKey="id" responsiveLayout="scroll" selectionMode="multiple" editMode="row"
  [(selection)]="selectedRows" (onRowSelect)="onRowSelect($event.data)" (onRowUnselect)="onRowUnselect($event)"
  [metaKeySelection]="!autoMultiSelect" [expandedRowKeys]="expandedRows" (click)="$event.stopPropagation()"
  [editingRowKeys]="editingRowKeys" sortMode="multiple">

  <ng-template pTemplate="header">
    <tr>
      @if (ehTabelaPrincipal) {
        <th></th>
        } <!-- espaço para o botão de expandir -->
        <th pSortableColumn="conciliado">Conciliado<p-sortIcon field="conciliado" /></th>
        <th pSortableColumn="data">Data<p-sortIcon field="data" /></th>
        <th pSortableColumn="lancamento">Lançamento<p-sortIcon field="lancamento" /></th>
        <th pSortableColumn="valor">Valor<p-sortIcon field="valor" /></th>
        <th style="width: 130px;"></th>
      </tr>
    </ng-template>

    <!-- Modelo da Tabela Principal -->
    <ng-template #body let-lancamento let-rowIndex="rowIndex" let-editing="editing" let-expanded="expanded">
      <tr [pSelectableRow]="lancamento" [pSelectableRowIndex]="rowIndex" [pEditableRow]="lancamento">
        @if (ehTabelaPrincipal) {
          <td>
            <p-button [ngClass]="{'display-none': !lancamento.ehAgrupador}" type="button" pRipple [pRowToggler]="lancamento"
              [text]="true" [rounded]="true" [plain]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
          </td>
        }
        <td>
          <mat-checkbox [checked]="lancamento.conciliado" (change)="onCheckboxClick($event, lancamento)"
          [disabled]="!modoEdicao || (lancamento.conciliado && lancamento.ehAgrupador)"></mat-checkbox>
        </td>
        <td>
          {{ lancamento.data | date:'dd/MM/yyyy' }}
        </td>
        <td>
          {{ lancamento.descricao }}
        </td>
        <td>
          <p-cellEditor>
            <ng-template #input>
              @if (!this.cardEhBanco) {
                <p-inputnumber type="text" mode="currency" currency="BRL" [(ngModel)]="lancamento.valor" />
              }
              @if (this.cardEhBanco) {
                <div [ngClass]="{'red-text': lancamento.valor < 0 }">{{ lancamento.valor | currency:'BRL' }}</div>
              }
            </ng-template>
            <ng-template #output>
              <app-tooltip [exibeTooltip]="lancamento.ehAgrupador && lancamento.valor !== lancamento.valorTotal" tituloTooltip="Total agrupado:">
                <div [ngClass]="{'red-text': lancamento.valor < 0 }" matBadge="&#8288;" matBadgeSize="small" matBadgeColor="primary"
                  [matBadgeHidden]="!(lancamento.ehAgrupador && lancamento.valor !== lancamento.valorTotal)">
                  {{ lancamento.valor | currency:'BRL' }}
                </div>
                <div menuContent>
                  <div [ngClass]="{'red-text': lancamento.valorTotal < 0 }">{{ lancamento.valorTotal | currency:'BRL' }}</div>
                </div>
              </app-tooltip>
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          @if (!editing) {
            <div class="inline-element items-center acoes-linha">
              <app-info-registro [info]="lancamento" [disabled]="lancamento.ehAgrupador" [disableSalvar]="(cardEhBanco && disableSalvarObservacaoBanco) || (!cardEhBanco && disableSalvarObservacaoCaixa)" (observacaoSalva)="editarObservacao(lancamento)"/>
              <button pButton pRipple type="button" matTooltip="Opções" [matMenuTriggerFor]="menu"
              icon="pi pi-ellipsis-v" text rounded severity="secondary"></button>
            </div>
          }

          @if (editing) {
            <div class="inline-element items-center acoes-linha">
              <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
              (click)="onRowEditSave(lancamento)" text rounded severity="secondary"></button>
              <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
              (click)="onRowEditCancel(lancamento)" text rounded severity="secondary"></button>
            </div>
          }
        </td>

        <mat-menu #menu="matMenu" xPosition="before">
          @if (!editing && !this.cardEhBanco) {
            <button mat-menu-item class="inline-element"
              [disabled]="!modoEdicao" [disableNoPermission]="permissaoEditarLancamento" (click)="onRowEditInit(lancamento)">
              <i class="pi pi-pencil accent-color menu-primeng-icon"></i>
              Editar valor
            </button>
          }
          <button mat-menu-item class="inline-element" [disabled]="!lancamento.conciliado || lancamento.ehAgrupador"
            (click)="visualizarCorrespondenciaClick(lancamento)">
            <i class="pi pi-eye accent-color menu-primeng-icon"></i>
            Visualizar Correspondencia
          </button>
          @if (!editing && this.cardEhBanco) {
            <button mat-menu-item class="inline-element"
              [disabled]="lancamento.ehAgrupador" [disableNoPermission]="permissaoEditarRegra" (click)="onCriarRegraClick(lancamento)">
              <i class="pi pi-bolt accent-color menu-primeng-icon"></i>
              Criar regra de conciliação automática
            </button>
          }
          <ng-container *hasPermission="permissaoEditarLancamento">
            @if (!editing && this.cardEhBanco) {
              <button mat-menu-item class="inline-element"
                [disabled]="lancamento.ehAgrupador" (click)="onAdicionarLoteCorrespondenteClick(lancamento)">
                <i class="pi pi-plus accent-color menu-primeng-icon"></i>
                Adicionar lote correspondente
              </button>
            }
          </ng-container>
          <ng-container *hasPermission="permissaoEditarLancamento">
            @if (!editing && !this.cardEhBanco) {
              <button mat-menu-item class="inline-element" [disabled]="!modoEdicao"
                (click)="onAlterarContaClick(lancamento)">
                <i class="pi pi-arrow-right-arrow-left accent-color menu-primeng-icon"></i>
                Alterar conta
              </button>
            }
          </ng-container>
          @if (!editing && !this.cardEhBanco) {
            <button mat-menu-item class="inline-element"
              [disabled]="!modoEdicao" [disableNoPermission]="permissaoEditarLancamento" (click)="onRowDeleteClick(lancamento)">
              <i class="pi pi-trash accent-color menu-primeng-icon"></i>
              Excluir
            </button>
          }
        </mat-menu>
      </tr>
    </ng-template>



    <!-- Modelo da Tabela secundaria -->
    @if (ehTabelaPrincipal) {
      <ng-template #expandedrow let-lancamento let-rowIndex="rowIndex" let-editing="editing">
        <tr [pSelectableRow]="lancamento" [pSelectableRowIndex]="rowIndex" [pEditableRow]="lancamento">
          <td colspan="6">
            <div class="table-container">
              <!-- Conteudo da tabela secundaria -->
              <app-lancamentos-table [lancamentosExibidos]="lancamento.lancamentosAgrupados" [ehTabelaPrincipal]="false"
                [cardEhBanco]="cardEhBanco" [modoEdicao]="modoEdicao" [autoMultiSelect]="autoMultiSelect"
                [conciliacaoId]="conciliacaoId" [lancamentoAgrupador]="lancamento" [selectedRows]="selectedRows"
                (selectedRowsChange)="onChildSelectionChange($event)">>
              </app-lancamentos-table>
            </div>
          </td>
        </tr>
      </ng-template>
    }

  </p-table>